import { MiscellaneousField } from '../../reportsTypes';
import { FieldEnabledState } from './MiscellaneousStringItem';
import { UseFormReturn, FieldValues } from 'react-hook-form';
import { MiscellaneousFieldRenderer } from './MiscellaneousFieldRenderer';
import React from 'react';
import { DateRange } from 'react-day-picker';

interface FieldGroupRendererProps<T extends FieldValues = FieldValues> {
  group: string[];
  miscellaneousFields: Record<string, MiscellaneousField>;
  fieldEnabledState: FieldEnabledState;
  form: UseFormReturn<T>;
  prefix: boolean;
  dateRange: DateRange | undefined;
}

export const FieldGroupRenderer = ({
  group,
  miscellaneousFields,
  fieldEnabledState,
  form,
  prefix,
  dateRange,
}: FieldGroupRendererProps) => {
  return group.length > 1 ? (
    <div className="grid grid-cols-2 gap-4">
      {group.map((fieldName) => (
        <MiscellaneousFieldRenderer
          key={fieldName}
          fieldName={fieldName}
          fieldInfo={miscellaneousFields[fieldName]}
          fieldEnabledState={fieldEnabledState}
          form={form}
          prefix={prefix}
          dateRange={dateRange}
        />
      ))}
    </div>
  ) : (
    <MiscellaneousFieldRenderer
      key={group[0]}
      fieldName={group[0]}
      fieldInfo={miscellaneousFields[group[0]]}
      fieldEnabledState={fieldEnabledState}
      form={form}
      prefix={prefix}
      dateRange={dateRange}
    />
  );
};
